// Admin panel modules whose access is set per position (Configuration >
// Job Positions). The keys match config/panel_modules.php in petwalkie-api;
// /me returns user.panel_modules as { key: level } for the modules the user
// can open (null for ADMIN / SUPER ADMIN, who can do everything).

// view: open and look; edit: also add and edit; full: also delete/restore
export const LEVELS = ["none", "view", "edit", "full"];

// Lowest level each action needs
const ACTION_LEVEL = { view: "view", add: "edit", edit: "edit", delete: "full" };

// "My franchise" screens: only meaningful for a franchisee admin, so the
// sidebar leaves them out for admins
export const ADMIN_HIDDEN_MODULES = [
  "leave_requests",
  "my_staff",
  "franchise_details",
  "kyc_documents",
];

export function moduleLevel(user, key) {
  if (!user) return "none";
  const modules = user.panel_modules;
  if (modules === null) return ADMIN_HIDDEN_MODULES.includes(key) ? "none" : "full";
  // An empty PHP array arrives as [], a filled one as an object
  if (!modules || Array.isArray(modules)) return "none";
  return LEVELS.includes(modules[key]) ? modules[key] : "none";
}

// keys: one module key or several (a screen shared by modules, e.g. the
// franchise staff list is both "franchisee_staffs" and "my_staff")
export function canDoModule(user, keys, action = "view") {
  const needed = LEVELS.indexOf(ACTION_LEVEL[action] || "full");
  return [].concat(keys).some((key) => {
    const level = moduleLevel(user, key);
    return level !== "none" && LEVELS.indexOf(level) >= needed;
  });
}

export function canAccessModule(user, key) {
  return canDoModule(user, key, "view");
}
